import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { role: "none" }
const _hoisted_2 = {
  key: 0,
  class: "border-t border-gray-200"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "w-6 h-6 mr-2 text-gray-600",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.03003 13.92H11.03V4.99997L13.04 4.96997V13.92H17.03L12.03 18.92L7.03003 13.92Z",
  fill: "#4B5563"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "w-6 h-6 mr-2 text-gray-600",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.03003 9.96997H11.03V18.89L13.04 18.92V9.96997H17.03L12.03 4.96997L7.03003 9.96997Z",
  fill: "#4B5563"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "ml-6" }

import { ref, watch, onBeforeUnmount, PropType } from 'vue'

interface SortOption {
  label: string
  value: string
  direction: 'asc' | 'desc'
  group: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SortOptionsModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  options: {
    type: Array as PropType<SortOption[]>,
    required: true
  },
  selectedValue: {
    type: String,
    required: true
  }
},
  emits: ["select", "update:isOpen"],
  setup(__props, { emit }) {

const props = __props;





const modalRef = ref<HTMLElement | null>(null)

function selectOption(value: string) {
  emit('select', value)
}

const handleClickOutside = (event: MouseEvent) => {
  if (modalRef.value && !modalRef.value.contains(event.target as Node)) {
    emit('update:isOpen', false)
  }
}

watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }
)

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  return (__props.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "modalRef",
        ref: modalRef,
        class: "absolute right-0 z-20 mt-2 w-72 origin-top-right border border-gray-200 rounded-lg bg-white shadow-lg focus:outline-none overflow-hidden",
        role: "menu",
        "aria-orientation": "vertical",
        "aria-labelledby": "menu-button",
        tabindex: "-1"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: option.value
            }, [
              (index > 0 && option.group !== __props.options[index - 1].group)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                href: "#",
                onClick: _withModifiers(($event: any) => (selectOption(option.value)), ["prevent"]),
                class: _normalizeClass([
            'flex items-center px-4 py-3 text-sm transition-colors',
            __props.selectedValue === option.value
              ? 'bg-gray-200 text-gray-900'
              : 'text-gray-700 hover:bg-gray-200'
          ]),
                role: "menuitem",
                tabindex: "-1"
              }, [
                (option.direction === 'asc')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9)),
                _createElementVNode("span", _hoisted_10, _toDisplayString(option.label), 1)
              ], 10, _hoisted_3)
            ], 64))
          }), 128))
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})